import MetricCategoryItem, { MetricCategoryItemStrings } from 'enums/MetricCategoryItem'
import CountType, { CountTypeStrings } from 'enums/CountType'
import messageUtil from 'utils/messageUtil'
import { MessageConst } from 'enums'
import kmeans from 'utils/kmeans'

import { InsightChartProps } from '../../types'

export const getBreakPercentage = (totalBars: number, index: number): number => {
  const percentFormula = (percent: number) => 70 + 30 * percent

  const restPercents = 1 - (1 / (totalBars - 1)) * index

  return percentFormula(restPercents)
}

export const getDisplayInsightValue = (value: number) => {
  const isOverBillion = value >= 1_000_000_000

  return Intl.NumberFormat('en-US', {
    notation: isOverBillion ? 'compact' : 'standard',
    maximumFractionDigits: 0
  }).format(value)
}

export const getDisplayAvg = (avg: number) =>
  Intl.NumberFormat('en-US', {
    maximumFractionDigits: 1
  }).format(avg)

export const getColorByCountType = (countType?: CountTypeStrings) => {
  switch (countType) {
    case CountType.MENTIONS:
      return 'metric.mainMetrics.mentions'
    case CountType.POSTS:
      return 'metric.mainMetrics.post'
    default:
      return 'metric.mainMetrics.post'
  }
}

export const getStarRatingName = (name?: MetricCategoryItemStrings) => {
  switch (name) {
    case MetricCategoryItem.FIVE_STAR:
      return '5'
    case MetricCategoryItem.FOUR_STAR:
      return '4'
    case MetricCategoryItem.THREE_STAR:
      return '3'
    case MetricCategoryItem.TWO_STAR:
      return '2'
    case MetricCategoryItem.ONE_STAR:
      return '1'
    case MetricCategoryItem.NO_RESPONSE_STAR:
      return MessageConst.NOT_AVAILABLE_ABBR
    default:
      return ''
  }
}

export const getSurveyScoreName = (name?: MetricCategoryItemStrings) => {
  if (name === MetricCategoryItem.NO_RESPONSE_SURVEY) return MessageConst.NOT_AVAILABLE_ABBR
  return messageUtil.measureType(name!) ?? ''
}

export const getSortedSetBreakInfo = (sortedSet: InsightChartProps['data']['set']) => {
  if (!sortedSet?.length) return { hasBreakSymbol: false, maxUnbreakValue: 0, breakAmount: 0 }

  let maxUnbreakValue = sortedSet[0].value!
  const hasBreakSymbol = sortedSet[0].value! - sortedSet[sortedSet.length - 1].value! > 1_000
  let breakAmount = 0

  if (hasBreakSymbol) {
    const clusters = kmeans(
      sortedSet.map((s) => s.value!),
      2
    )
    const [smallCluster, largeCluster] = clusters
    breakAmount = largeCluster.length
    maxUnbreakValue = smallCluster[smallCluster.length - 1]
  }
  return { maxUnbreakValue, breakAmount, hasBreakSymbol }
}

export const getPercentageByIndexandBreakInfo = (
  { value, totalBars, index }: { value: number; totalBars: number; index: number },
  {
    maxUnbreakValue,
    breakAmount,
    hasBreakSymbol
  }: { maxUnbreakValue: number; breakAmount: number; hasBreakSymbol: boolean }
) => {
  let percentage = 0

  if (hasBreakSymbol) {
    percentage =
      index < breakAmount ? getBreakPercentage(totalBars, index) : (value / maxUnbreakValue) * 55
  } else {
    percentage = (value / maxUnbreakValue) * 100
  }
  return percentage
}
